import { render, staticRenderFns } from "./Binnacle.vue?vue&type=template&id=502239a0&scoped=true"
import script from "./Binnacle.vue?vue&type=script&lang=js"
export * from "./Binnacle.vue?vue&type=script&lang=js"
import style0 from "./Binnacle.vue?vue&type=style&index=0&id=502239a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502239a0",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/extranet/Binnacle.vue
// module id = 240
// module chunks = 31